import React, {useState} from 'react';
import NoDataRow from "../../../../../../components/reports/no-data-row.jsx";
import {safeFormatDateTime} from "../utils/safe-operations.jsx";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";

const DispatchListContent = ({ data, boName }) => {
    const navigate = navigateHook();
    const dispatch_list = data?.dispatch_list ?? [];

    const [limit, setLimit] = useState(10)
    const passedLimit = dispatch_list.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 10)
    }

    return (
        <>
            <div className="mt-4 mb-6 table-div">
                <span className="table-title mb-2">Lista de despachos {(passedLimit && limit) ? ` (TOP ${limit})` : ''}</span>

                <table id="dispatch-list-data" className="table report-table mt-2" sheet-name={'Lista de despachos'}>
                    <thead className="thead-background">
                        <tr className="text-left">
                            <th className="w-[5%]">ID</th>
                            <th className="w-[12%]">Talão</th>
                            <th className="w-[14%]">{boName}</th>
                            <th className="w-[45%]">Natureza</th>
                            <th className="w-[12%]">D/H inicial</th>
                            <th className="w-[12%]">D/H final</th>
                        </tr>
                    </thead>

                    <tbody>
                        { !dispatch_list?.length ? (
                            <NoDataRow colSpan={6} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : (limit ? dispatch_list.slice(0, limit) : dispatch_list).map((element, index) => {
                            const url = `/despacho/dispatch/form/${element.dispatch_id}`;
                            const urlBo = `/bo/redirect/${element.bo?.replace('/', '-')}`;

                            return (
                                <>
                                    <tr key={index}>
                                        <td className="w-[5%]"><a onClick={() => navigate(url, true)} className={'inner-link'}>{element.dispatch_id ?? ''}</a></td>
                                        <td className="w-[12%]">{element.checkbook}</td>
                                        <td className="w-[14%]">{element.bo !== '-' ? (<a onClick={() => navigate(urlBo, true)} className={'inner-link'}>{element.bo ?? ""}</a>) : (element.bo)}</td>
                                        <td className="w-[45%]">{element.dispatch_nature}</td>
                                        <td className="w-[12%]">{safeFormatDateTime(element.dispatch_start)}</td>
                                        <td className="w-[12%]">{safeFormatDateTime(element.dispatch_end)}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1">
                        <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                            {limit ? "Ver mais" : "Ver menos"}
                        </span>
                    </div>
                }

            </div>
        </>
    );
};

export default DispatchListContent;
